// src/components/Hero.jsx
import { useEffect, useRef } from 'react';
import { buildWaLink } from '../utils/whatsapp';

const WA_PHONE = process.env.REACT_APP_WA_PHONE || '';

export default function Hero() {
  const vRef = useRef(null);

  const waText =
    'Hola Muelle85 👋 Quiero obtener mi viaje de prueba para Terra Trailers. Vengo desde la landing.';
  const waHref = buildWaLink(waText, WA_PHONE);

  useEffect(() => {
    const v = vRef.current;
    if (!v) return;

    // asegurar flags compatibles con iOS
    v.muted = true;
    v.defaultMuted = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');

    const tryPlay = () => {
      v.removeAttribute('controls');
      try { v.play().catch(() => {}); } catch {}
    };

    const onCanPlay = () => tryPlay();
    const onGesture = () => {
      tryPlay();
      window.removeEventListener('pointerdown', onGesture);
      window.removeEventListener('touchstart', onGesture);
    };
    const onVis = () => { if (!document.hidden) tryPlay(); };

    v.addEventListener('canplay', onCanPlay);
    window.addEventListener('pointerdown', onGesture, { once: true });
    window.addEventListener('touchstart', onGesture, { once: true, passive: true });
    document.addEventListener('visibilitychange', onVis);

    tryPlay();

    return () => {
      v.removeEventListener('canplay', onCanPlay);
      window.removeEventListener('pointerdown', onGesture);
      window.removeEventListener('touchstart', onGesture);
      document.removeEventListener('visibilitychange', onVis);
    };
  }, []);

  return (
    <section id="hero" className="hero" aria-label="Hero principal">
      <div id="top" className="hero__media">
        <video
          ref={vRef}
          className="hero__video"
          src="/video/hero_optimizado.webm"
          poster="/img/hero-poster.webp"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          controls={false}
          controlsList="nodownload nofullscreen noplaybackrate"
          disablePictureInPicture
        />
        <div className="hero__tint" aria-hidden="true" />
        <div className="hero__gradient" aria-hidden="true" />
      </div>

      <div className="hero__content container">
        <span className="eyebrow">Terra Trailers</span>
        <h1>
          No es para los que viajan.<br />
          Es para los que <strong>VIVEN</strong>.
        </h1>

        <a
          className="footer__cta"
          href={waHref}
          target="_blank"
          rel="noopener noreferrer"
        >
          Obtené tu viaje de prueba
        </a>
      </div>
    </section>
  );
}
